// generated from 10 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const purchaseScoreFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("purchase_score_filter"),
  comparison_key: z.enum([
    "3", // 9 (90.00%)
    "5", // 1 (10.00%)
  ]),
  display_name: z.object({
    id: common.objectId,
    value: z.string(),
  }),
  // undefined: 5 (50.00%), defined 5 (50.00%)
  raw_value: z.int().optional(),
  value: z.int(),
  varies_by_app_group: z.literal(false),
});
